import { OPERATORS } from './Operators'
import {
  Is,
  IsNot,
  IsAny,
  IsNotAny,
  Contains,
  DoesNotContain,
  StartsWith,
  DoesNotStartWith,
  EndsWith,
  DoesNotEndWith,
  IsPresent,
  IsNotPresent,
  Gte,
  Lte,
  Gt,
  Lt,
  Between,
  NotBetween,
  IsBefore,
  IsNotBefore,
  IsAfter,
  IsNotAfter,
  IsBeforeRelative,
  IsAfterRelative,
  HasOccurredExactly
} from 'components/ContactFilterBuilder/Operators'

const {
  IS,
  IS_NOT,
  IS_ANY,
  IS_NOT_ANY,
  CONTAINS_EXACT,
  DOES_NOT_CONTAIN_EXACT,
  STARTS_WITH,
  DOES_NOT_START_WITH,
  ENDS_WITH,
  DOES_NOT_END_WITH,
  IS_PRESENT,
  IS_NOT_PRESENT,
  GTE,
  LTE,
  GT,
  LT,
  BETWEEN,
  NOT_BETWEEN,
  IS_BEFORE,
  IS_NOT_BEFORE,
  IS_AFTER,
  IS_NOT_AFTER,
  IS_BEFORE_RELATIVE,
  IS_AFTER_RELATIVE,
  HAS_OCCURRED_EXACTLY
} = OPERATORS

export const OPERATOR_COMPONENTS = {
  [IS]: Is,
  [IS_NOT]: IsNot,
  [IS_ANY]: IsAny,
  [IS_NOT_ANY]: IsNotAny,
  [CONTAINS_EXACT]: Contains,
  [DOES_NOT_CONTAIN_EXACT]: DoesNotContain,
  [STARTS_WITH]: StartsWith,
  [DOES_NOT_START_WITH]: DoesNotStartWith,
  [ENDS_WITH]: EndsWith,
  [DOES_NOT_END_WITH]: DoesNotEndWith,
  [IS_PRESENT]: IsPresent,
  [IS_NOT_PRESENT]: IsNotPresent,
  [GTE]: Gte,
  [LTE]: Lte,
  [GT]: Gt,
  [LT]: Lt,
  [BETWEEN]: Between,
  [NOT_BETWEEN]: NotBetween,
  [IS_BEFORE]: IsBefore,
  [IS_NOT_BEFORE]: IsNotBefore,
  [IS_AFTER]: IsAfter,
  [IS_NOT_AFTER]: IsNotAfter,
  [IS_BEFORE_RELATIVE]: IsBeforeRelative,
  [IS_AFTER_RELATIVE]: IsAfterRelative,
  [HAS_OCCURRED_EXACTLY]: HasOccurredExactly
}